import { render, staticRenderFns } from "./ScreenGroupsItem.vue?vue&type=template&id=533d97d4&scoped=true&"
import script from "./ScreenGroupsItem.vue?vue&type=script&lang=js&"
export * from "./ScreenGroupsItem.vue?vue&type=script&lang=js&"
import style0 from "./ScreenGroupsItem.scss?vue&type=style&index=0&id=533d97d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d97d4",
  null
  
)

export default component.exports